/*global google*/

import React from 'react';
import { Marker } from 'react-google-maps';
import MarkerWithLabel from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox';

import { ROLES } from 'config/constants';
import { getAbbreviateNumber } from 'utils/getAbbreviateNumber';
import { InfoBoxItem } from '../InfoboxItem';
import Spiderfy from './Spiderfy';

const Markers = ({
  listData = [],
  onMouseOver,
  onMouseOut,
  onMarkerClick,
  handleClustererMarkerClick,
  activeLocationId,
  openedInfoBox,
  activeMarkerImg,
  activeLocationData,
  isInfoProcessed,
}) => {
  const listMarkers = [];

  listData.forEach((item) => {
    const {
      id,
      count,
      radius,
      point = {},
      reserchSite: { id: researchId, group = '', locations = [] } = {},
      type,
    } = item;
    const isInactiveResearchSite = group === ROLES.INACTIVE_RESEARCH_SITE;
    const activeMarkerIcon = isInactiveResearchSite
      ? './assets/images/svg/change-map-icon-inactive.svg'
      : activeMarkerImg;
    const markerIcon = isInactiveResearchSite
      ? './assets/images/svg/inactive-pin.svg'
      : './assets/images/svg/default-map-icon.svg';

    if (type === 2) {
      const labelAnchor =
        count < 999
          ? new google.maps.Point(3.5 * count.toString().length, 49)
          : new google.maps.Point(2.4 * getAbbreviateNumber(count).length, 47);

      listMarkers.push(
        <MarkerWithLabel
          key={id}
          position={{ lat: point.y, lng: point.x }}
          labelAnchor={labelAnchor}
          labelStyle={{ fontSize: count > 999 ? '10px' : '12px' }}
          icon="./assets/images/svg/marker-clasterer.svg"
          onClick={() =>
            handleClustererMarkerClick(
              { lat: point.y, lng: point.x },
              radius,
              count,
            )
          }
        >
          <div>{getAbbreviateNumber(count)}</div>
        </MarkerWithLabel>,
      );
    }

    if (type === 1) {
      locations.forEach(
        ({ locationAddress: { point = {} } = {}, id: locationId = '' }) => {
          listMarkers.push(
            <Marker
              key={locationId}
              icon={{
                url:
                  activeLocationId === locationId &&
                  openedInfoBox === activeLocationId
                    ? activeMarkerIcon
                    : markerIcon,
              }}
              position={{ lat: point.y, lng: point.x }}
              onMouseOver={onMouseOver}
              onMouseOut={onMouseOut}
              params={{ id: researchId, locationId }}
            >
              {activeLocationId === locationId &&
                openedInfoBox === activeLocationId && (
                  <InfoBox
                    options={{
                      closeBoxURL: ``,
                      enableEventPropagation: true,
                      pixelOffset:
                        group === 'InactiveResearchSite'
                          ? new google.maps.Size(-157, -13)
                          : new google.maps.Size(-293, -13),
                    }}
                  >
                    <InfoBoxItem
                      group={group}
                      activeLocationData={activeLocationData ?? {}}
                      isInfoProcessed={isInfoProcessed}
                    />
                  </InfoBox>
                )}
            </Marker>,
          );
        },
      );
    }
  });

  return <Spiderfy onSpiderClick={onMarkerClick}>{listMarkers}</Spiderfy>;
};

export { Markers };
